<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-recordings-list-view" class="data-list-container">
    <!-- fields list modal -->
    <vs-prompt
      class="active-fields-modal"
      title="Campos Ativos"
      accept-text="OK"
      :active.sync="activeFieldsModal"
    >
      <div
        v-for="item in availableFields"
        :key="item.name"
        class="active-fields-item"
        :class="{ default: item.default, active: item.active }"
      >
        <vs-switch
          :id="'custom-input-' + item.name"
          class="active-fields-btn"
          :class="{ default: item.default, active: item.active }"
          icon-pack="feather"
          v-model="item.active"
        />
        <span
          class="active-fields-text"
          :class="{ default: item.default, active: item.active }"
          >{{ item.text }}</span
        >
      </div>
    </vs-prompt>
    <!-- fields list modal -->

    <div id="data-cardlist-list">
      <div class="no-records" v-if="loadedData && recordings.length === 0">
        <p>Não há dados disponíveis</p>
      </div>

      <div class="loading-recordings-row" v-if="firsLoading">
        <vs-row vs-justify="center">
          <i class="fas fa-spinner fa-spin"></i>
        </vs-row>
        <p>Buscando gravações. Aguarde...</p>
      </div>
      <div v-if="!busy && !firsLoading">
        <router-link
          :key="indextr"
          v-for="(tr, indextr) in recordings"
          :to="`/gravacoes/${tr.recording.id}`"
          class="cardlist-link"
        >
          <vs-card class="cardlist-data">
              <div class="card-relative">
              <div :class="'status-chip ' + getStatusColorRecordings(tr.recording.recordingState)">
                  {{ getStatusText(tr.recording.recordingState) }}
              </div>

            <div class="item-header">
              <div class="photo-container">
                <img :src="tr.recording.program.photo" />
              </div>
              <div class="description-container">
                <span class="program-title">{{
                  tr.recording.program.name | formatProgramName
                }}</span>
                <vs-row>
                  <div class="date-time-chip">
                    <feather-icon
                      icon="CalendarIcon"
                      svgClasses="h-4 w-4"
                      style="margin-right: 5px"
                    />
                    {{ tr.recording.date | formatDate }}
                  </div>
                  <div class="date-time-chip" style="margin-left: 10px;">
                    {{ tr.recording.time | formatTime }}h
                  </div>
                </vs-row>
                <vs-row>
                    <div class="min-height-row">
                        <span>Idade mínima:</span><span><strong>{{ tr.recording.ageMin }} anos</strong></span>
                    </div>
                </vs-row>
              </div>
            </div>
            <div class="status-container">
              <div class="col-status">
                <div class="card-status">
                  <div class="status-info">
                    {{ tr.numberMen  + tr.vacancies }}
                  </div>
                  <span>Solicitados</span>
                </div>
              </div>
              <div class="col-status">
                <div class="card-status">
                  <div class="status-info">
                    {{ tr.recording.caravanistsAssigned | extractAwaiting }}
                  </div>
                  <span>Aguardando</span>
                </div>
              </div>
              <div class="col-status">
                <div class="card-status">
                  <div class="status-info">
                   {{
                      tr.recording.caravanistsAssigned | extractConfirmed
                    }}
                  </div>
                  <span>Confirmados</span>
                </div>
              </div>
            </div>

            <div
              v-for="item in activeFields"
              :key="item.name"
              class="cardlist-row"
              :class="['cardlist-row-' + item.name, getClass(item.name)]"
            >
              <div
                class="cardlist-item item-title"
                v-if="item.name === 'name'"
                :class="'cardlist-item-' + item.name"
              >
                {{ tr.recording.program && tr.recording.program.name
                }}{{
                  tr.recording.frame && tr.recording.frame.name
                    ? ` (${tr.recording.frame.name})`
                    : ""
                }}
              </div>

              <div
                v-else-if="item.name === 'status'"
                class="cardlist-item"
                :class="'cardlist-item-' + item.name"
              >
                <span class="item-title">{{ item.text }}:</span>
                <span
                  :class="getStatusColor(tr.recording.status)"
                  class="item-text"
                >
                  {{ tr.recording.status ? "Ativo" : "Inativo" }}
                </span>
              </div>
            </div>
              </div>
          </vs-card>
        </router-link>
      </div>
    </div>
      <div class="loading-recordings-row" v-if="busy">
          <vs-row vs-justify="center">
              <i class="fas fa-spinner fa-spin"></i>
          </vs-row>
          <p>Buscando gravações...</p>
      </div>

    <pagination
      v-if="!busy && !firsLoading"
      :totalPages="totalPageCount"
      :currentPage="currentPage"
      :isWorking="isWorking"
      :onPageChange="handleChangePage"
      :totalContacts="totalItems"
    />
  </div>
</template>

<script>
import moduleRecording from "@/store/recording/moduleRecording.js";
import pagination from "@/components/pagination.vue";

export default {
  components: {
    pagination,
  },
  data() {
    return {
      firsLoading: false,
      currentPage: 1,
      busy: false,
      isWorking: false,
      offset: 0,
      loadedData: false,
      selected: [],
      itemsPerPage: 20,
      isMounted: false,
      activePrompt: false,
      activeFieldsModal: false,
      availableFields: [
        { name: "vacancies", text: "Solicitados", active: true, default: true },
        { name: "confirmed", text: "Confirmado", active: true, default: true },
        { name: "ageMin", text: "Idade Mínima", active: true, default: true },
        { name: "awaiting", text: "Aguardando", active: true, default: true },
        { name: "frameStatus", text: "Status do Quadro", active: false },
        {
          name: "status",
          text: "Status da Gravação",
          active: false,
          default: false,
        },
      ],
    };
  },
  computed: {
    activeFields() {
      return this.availableFields.filter((item) => {
        return item.active;
      });
    },
    recordings() {
      return this.$store.state.recording.recordings;
    },
    totalItems() {
      return +this.$store.state.recording.totalItems || 0;
    },
    totalPageCount() {
      const totalItems = +this.totalItems;
      const itemsPerPage = this.itemsPerPage || 10;

      const increased = totalItems % itemsPerPage > 0;

      let totalPages = parseInt(totalItems / itemsPerPage) || 0;
      if (increased) {
        totalPages++;
      }

      return totalPages || 0;
    },
    totalItems() {
      return +this.$store.state.recording.totalItems;
    },
    totalPages() {
      return this.$store.state.participant.totalItems;
    },
  },
  methods: {
    getStatusText(status) {
        if (status === 'Cancelada' || status === 'Encerrada') {
            return "cancelado";
        }
        return "ativo"
    },
    getStatusColorRecordings(status) {
        if (status === 'Cancelada' || status === 'Encerrada') {
            return "status-cancelada";
        }
        return "status-neutro"
    },
    getClass(item) {
      switch (item) {
        case "date":
        case "time":
        case "vacancies":
        case "ageMin":
        case "status":
        case "confirmed":
        case "awaiting":
        case "frameStatus":
          return "half";
        default:
          break;
      }
      return "";
    },
    handleChangePage(page, isSearch = true) {
      if (this.isWorking) return;
      this.currentPage = page;

      this.busy = true;
      this.setLoading(true);

      const offset = this.currentPage * this.itemsPerPage - this.itemsPerPage;

      this.$store
        .dispatch("recording/fetchRecordings", {
          limit: this.itemsPerPage,
          offset,
        })
        .finally(() => {
          this.setLoading(false);
          this.busy = false;
          if (
            this.recordings.length !== 0 &&
            this.recordings.length % this.itemsPerPage === 0 &&
            this.totalItems > this.recordings.length
          ) {
            window.scrollBy(0, -window.innerHeight);
            this.loadedData = true;
          }
        });
    },
    openFieldsModal() {
      this.activeFieldsModal = true;
    },
    deleteData(id) {
      this.$store.dispatch("dataList/removeItem", id).catch((err) => {
        console.error(err);
      });
    },
    getStatusColor(status) {
      return !status ? "danger" : "success";
    },
    setLoading(value) {
      this.isWorking = value === true;
    },
    loadMore() {
      this.busy = true;
      this.setLoading(true);

      this.offset += this.itemsPerPage;

      this.$store
        .dispatch("recording/fetchRecordings", {
          limit: this.itemsPerPage,
          offset: this.offset,
        })
        .finally(() => {
          this.busy = false;
          this.setLoading(false);
          if (
            this.recordings.length !== 0 &&
            this.recordings.length % this.itemsPerPage === 0 &&
            this.totalItems > this.recordings.length
          ) {
            window.scrollBy(0, -window.innerHeight);
            this.busy = false;
          }
        });
    },
  },
  filters: {
    extractConfirmed: function (caravanistsArr) {
      if (!caravanistsArr) return 0;
      return (
        (caravanistsArr[0] && caravanistsArr[0].caravanist.confirmation) || 0
      );
    },
    extractAwaiting: function (caravanistsArr) {
      if (!caravanistsArr) return 0;
      return (caravanistsArr[0] && caravanistsArr[0].caravanist.awaiting) || 0;
    },
    formatProgramName: function (name) {
      if (name) {
        if (name.length > 24) {
          return name.substr(0, 24) + "...";
        }
        return name;
      }
      return "";
    },
    formatDate: function (date) {
      if (!date) return;
      return date.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1");
    },
    formatTime: function (time) {
      if (!time) return;
      return time.replace(":00", "");
    },
  },
  created() {
    if (!moduleRecording.isRegistered) {
      this.$store.registerModule("recording", moduleRecording);
      moduleRecording.isRegistered = true;
    }
    this.firsLoading = true;

    this.$store
      .dispatch("recording/fetchRecordings", {
        limit: this.itemsPerPage,
        offset: 0,
      })
      .finally(() => {
        this.firsLoading = false;
        this.setLoading(false);
        this.loadedData = true;

        if (
          this.recordings.length !== 0 &&
          this.recordings.length % this.itemsPerPage === 0 &&
          this.totalItems > this.recordings.length
        ) {
          window.scrollBy(0, -window.innerHeight);
          this.busy = false;
        }
      });
  },
  mounted() {
    this.isMounted = true;
    this.setLoading(true);
  },
};
</script>

<style lang="scss" scoped>
.loading-recordings-row {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 30px;
  min-height: 400px;
}
.loading-recordings-row i {
  font-size: 30px;
}

.status-agendada {
  background-color: #1e90ff;
}
.status-cancelada {
  background-color: red;
}
.status-finalizada {
  background-color: green;
}
.status-neutro {
  background-color: green;
}
.status-pendente {
  background-color: orange;
}
.min-height-row {
  margin-top: 4px;
}
.min-height-row strong {
  margin-left: 4px;
}
.card-relative {
  position: relative;
}

.status-chip {
    --f: 2px; /* control the folded part */
    color: #fff;
    position: absolute;
    font-size: 12px;
    top: -10px;
    left: -10px;
    line-height: 1.4;
    padding-inline: 16px;
    padding-bottom: var(--f);
    border-image: conic-gradient(#0008 0 0) 51%/var(--f);
    clip-path: polygon(
                    100% calc(100% - var(--f)),100% 100%,calc(100% - var(--f)) calc(100% - var(--f)),var(--f) calc(100% - var(--f)), 0 100%,0 calc(100% - var(--f)),999px calc(100% - var(--f) - 999px),calc(100% - 999px) calc(100% - var(--f) - 999px));
    transform: translate(calc((cos(45deg) - 1)*100%), -100%) rotate(-45deg);
    transform-origin: 100% 100%
}
.status-container {
  margin-top: 5px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.col-status {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  max-width: 120px;
  min-width: 100px;
}
.card-status {
  display: flex;
  flex-direction: column;
}
.status-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-size: 17px;
  font-weight: bold;
}
.status-info i {
  color: #aaa;
  margin-right: 3px;
}

.date-time-chip {
  display: flex;
  font-size: 15px;
  flex-direction: row;
  color: #3d4451;
  border-radius: 3px;
  margin-right: 14px;
}

.item-header {
  display: flex;
  flex-direction: row;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
}
.photo-container {
  width: 100px;
  height: 70px;
  background: #ccc;
  border-radius: 5px;
}
.photo-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}
.description-container {
  padding: 1px 0 2px 12px;
  display: flex;
  flex-direction: column;
}
.program-title {
  color: #000;
  margin-bottom: 2px;
  font-size: 16px;
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
#recordings-cardlist {
  .data-list-btn-container {
    width: auto;
  }
}
.item-text {
  margin-left: 0;
}
.con-vs-card {
  border: 1px solid #eee;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.1), 0px 1px 1px 0px rgba(0, 0, 0, 0.07), 0px 1px 3px 0px rgba(0, 0, 0, 0.06);
}

@media screen and (max-width: 420px) {
  #data-cardlist-list {
    .cardlist-link {
      .con-vs-card {
        margin-bottom: 8px !important;
      }
      .cardlist-row-name {
        .item-title {
          margin: -4px 0 4px;
        }
      }
    }
  }
}
</style>
